const LeadContactHistoryService = {
  formatDateToTimestamp(dateString) {
    // Convert date string (YYYY-MM-DD) to timestamp format (YYYY-MM-DDTHH:mm:ss)
    if (!dateString) return null;
    
    // If already in timestamp format, return as is
    if (dateString.includes('T')) return dateString;
    
    // Add time component (default to 00:00:00)
    return `${dateString}T00:00:00`;
  },

  async createContactHistory(formData) {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const url = '/api/lead/history';
      const method = 'POST';

      const updatedData = {
        ...formData,
        contactDate: this.formatDateToTimestamp(formData.contactDate),
        contactType: formData.contactType.value,
        profileIdentifier: profileLogged.identifier,
        leadIdentifier: formData.leadIdentifier
      };

      console.log('Creating contact history:', updatedData);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });

      if (response.ok) {
        const newContactHistory = await response.json();
        console.log('Contact History has been created:', newContactHistory);
        return newContactHistory;
      }
    } catch (error) {
      console.log('Error creating Contact History', error);
      throw error;
    }
  },

  async updateContactHistory(identifier, formData) {
    try {
      const url = '/api/lead/history/' + identifier;
      const method = 'PUT';
      delete formData.profile;
      delete formData.lead;
      const updatedData = {
        ...formData,
        contactDate: this.formatDateToTimestamp(formData.contactDate),
        contactType: formData.contactType.value
      };

      console.log('Updating contact history:', updatedData);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });

      if (response.ok) {
        const updatedContactHistory = await response.json();
        console.log('Contact History has been updated:', updatedContactHistory);
        return updatedContactHistory;
      }
    } catch (error) {
      console.log('Error updating Contact History', error);
      throw error;
    }
  },

  async retrieveContactHistory(identifier) {
    try {
      const response = await fetch('/api/lead/history/' + identifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Contact History', error);
      throw error;
    }
  },

  async retrieveAllContactHistoryByLead(leadIdentifier) {
    try {
      const response = await fetch('/api/lead/history/' + leadIdentifier + '/all');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Contact History for lead', error);
      throw error;
    }
  },

  async deleteContactHistory(identifier) {
    try {
      const url = '/api/lead/history/' + identifier;
      const method = 'DELETE';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const deletedContactHistory = await response.json();
        console.log('Contact History has been deleted:', deletedContactHistory);
        return deletedContactHistory;
      }
    } catch (error) {
      console.log('Error deleting Contact History', error);
      throw error;
    }
  }
};

export default LeadContactHistoryService;
